import { all, call, put, select, take, takeLatest } from 'redux-saga/effects';
import { normalize } from 'normalizr';
import { push } from 'react-router-redux';

import * as api from 'api';
import * as schemas from 'schemas';

import { getActiveCustomer } from 'store/auth';

import {
  SELECT_CUSTOMER_REQUEST,
  selectCustomerSuccess,
  selectCustomerFailure
} from 'store/customers';

import {
  FETCH_CUSTOMER_CREDIT_REQUEST,
  fetchCustomerCreditSuccess,
  fetchCustomerCreditFailure
} from 'store/customerCredit';

import {
  FETCH_REGION_SUCCESS,
  FETCH_REGION_FAILURE,
  fetchRegionRequest
} from 'store/region';

import {
  FETCH_REFERRAL_COUPON_SUCCESS,
  FETCH_REFERRAL_COUPON_FAILURE,
  fetchReferralCouponRequest
} from 'store/referralCoupon';

function* handleSelectCustomerRequest(action) {
  try {
    yield call(fetchCustomerEntities);

    yield localStorage.setItem('activeCustomerId', action.payload.id);

    yield put(selectCustomerSuccess(action.payload.id));
    yield put(push('/overview'));
  } catch (err) {
    yield put(selectCustomerFailure(err));
  }
}

function* handleFetchCustomerCreditRequest(action) {
  try {
    const customer = yield select(getActiveCustomer);
    const customerCredit = yield call(api.fetchCustomerCredit, customer.id);

    const response = normalize(customerCredit, schemas.customerCredit);

    yield put(fetchCustomerCreditSuccess(response));
  } catch (err) {
    yield put(fetchCustomerCreditFailure(err));
  }
}

export default function* customersSaga() {
  yield all([
    takeLatest(SELECT_CUSTOMER_REQUEST, handleSelectCustomerRequest),
    takeLatest(FETCH_CUSTOMER_CREDIT_REQUEST, handleFetchCustomerCreditRequest)
  ]);
}

export function* fetchCustomerEntities() {
  yield put(fetchRegionRequest(2));

  const action = yield take([FETCH_REGION_SUCCESS, FETCH_REGION_FAILURE]);

  if (action.error) {
    throw action.payload;
  }

  yield put(fetchReferralCouponRequest(2));

  yield take([FETCH_REFERRAL_COUPON_SUCCESS, FETCH_REFERRAL_COUPON_FAILURE]);
}



// WEBPACK FOOTER //
// ./src/store/customers/sagas.js